import '../scss/index.scss';

import serviceWorker from './modules/serviceworker';
import * as accordion from './modules/accordion';
import * as carousel from './modules/carousel';
import * as copy from './modules/copy';
import * as corona from './modules/corona/index';
import * as sources from './modules/sources';
import * as form from './modules/form';
import * as header from './modules/header';
import * as helpcenter from './modules/helpcenter';
import * as helpcenterSearch from './modules/helpcenter-search';
import * as jobs from './modules/jobs';
import * as modal from './modules/modal';
import * as navigation from './modules/navigation';
// import * as newsletter from './modules/newsletter';
import * as pageBanner from './modules/page-banner';
import * as progressbar from './modules/progressbar';
import * as stickycta from './modules/stickycta';
import * as press from './modules/press';
// import * as survey from './modules/survey';

serviceWorker.init();
accordion.init();
carousel.init();
copy.init();
sources.init();
form.init();
// survey.init();
header.init();
helpcenter.init();
helpcenterSearch.init();
jobs.init();
modal.init();
navigation.init();
// newsletter.init();
pageBanner.init();
progressbar.init();
press.init();
stickycta.init();
corona.init();
